import { render, staticRenderFns } from "./PillIcon.vue?vue&type=template&id=6b42dcc8&scoped=true&"
import script from "./PillIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PillIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b42dcc8",
  null
  
)

export default component.exports